import types from 'redux/types';
import Queue from 'helpers/queue';
import { checkTypeValue } from 'helpers';
import {
  fetchSendInbox,
  fetchSendInboxSuccess,
  fetchSendInboxFailed,
  baseSendInbox,
} from 'redux/handleReducers';
import components, { typeUnmounted } from 'consts/components';

const {
  REQUEST_API_SERVLET,
  REQUEST_API_SERVLET_SUCCESS,
  REQUEST_API_SERVLET_FAILED,
  REQUEST_CLEAR_SERVLET,
  REQUEST_SEND_INBOX_SERVLET,
  REQUEST_SEND_INBOX_SERVLET_FAILED,
  REQUEST_SEND_INBOX_SERVLET_SUCCESS,
  REQUEST_SEND_SERVLET,
  REQUEST_SEND_SERVLET_SUCCESS,
  REQUEST_SEND_SERVLET_FAILED,
  REQUEST_SPIN_SERVLET,
  REQUEST_SPIN_SERVLET_SUCCESS,
  REQUEST_SPIN_SERVLET_FAILED,
  REQUEST_CLEAR_SPIN,
  REQUEST_PREVIEW_SPIN,
  REQUEST_PREVIEW_SPIN_SUCCESS,
  REQUEST_PREVIEW_SPIN_FAILED,
  REQUEST_CLEAR_PREVIEW_SPIN,
  REQUEST_HISTORY_BY_ID,
  REQUEST_HISTORY_BY_ID_SUCCESS,
  REQUEST_HISTORY_BY_ID_FAILED,
  REQUEST_MORE_HISTORY,
  REQUEST_MORE_HISTORY_SUCCESS,
  REQUEST_MORE_HISTORY_FAILED,
  IS_LAST_HISTORY,
  REQUEST_PAUSE_LOAD_HISTORY,
  REQUEST_PAUSE_LOAD_HISTORY_FAILED,
  REQUEST_PAUSE_LOAD_HISTORY_SUCCESS,
  REQUEST_CONTINUE_HIST,
  REQUEST_CONTINUE_HIST_FAILED,
  REQUEST_CONTINUE_HIST_SUCCESS,
  REQUEST_MARK_AS_COMPLETED,
  REQUEST_MARK_AS_COMPLETED_FAILED,
  REQUEST_MARK_AS_COMPLETED_SUCCESS,
  REQUEST_UPDATE_MESSAGE_HIST,
  REQUEST_UPDATE_MESSAGE_HIST_SUCCESS,
  REQUEST_UPDATE_MESSAGE_HIST_FAILED,
  REQUEST_FILTER_CAMPAIGN,
  REQUEST_FILTER_CAMPAIGN_FAILED,
  REQUEST_FILTER_CAMPAIGN_SUCCESS,
  REQUEST_PHONE_NUMBERS,
  REQUEST_PHONE_NUMBERS_SUCCESS,
  REQUEST_PHONE_NUMBERS_FAILED,
  REQUEST_REFRESH_CAMPAIGN,
  REQUEST_REFRESH_CAMPAIGN_SUCCESS,
  REQUEST_REFRESH_CAMPAIGN_FAILED,
  REQUEST_SWITCH_STATUS_ROUTE_HISTORY_SUCCESS,
  REQUEST_SORTING_CAMPAIGN,
  REQUEST_SORTING_CAMPAIGN_SUCCESS,
  REQUEST_SORTING_CAMPAIGN_FAILED,
  REQUEST_PULL_REVENUE_CAMPAIGN,
  REQUEST_PULL_REVENUE_CAMPAIGN_SUCCESS,
  REQUEST_PULL_REVENUE_CAMPAIGN_FAILED,
  REQUEST_UPDATE_STATUS_CONTACT_GROUP_SUCCESS,
} = types;

const queueRequest = new Queue();
const queueContinue = new Queue();
const queueMarkAsComplete = new Queue();
const queueFetchingCreativeCampaign = new Queue();
const queueRefreshing = new Queue();

const initialState = {
  isFetching: true,
  isPreview: false,
  isFiltering: false,
  isLoadMore: undefined,
  isLastHistory: undefined,
  isPausing: undefined,
  isContinuing: undefined,
  isMarking: undefined,
  isSaving: undefined,
  isFetchingServlet: false,
  isSorting: false,
  isPullingRevenue: false,

  listStringPreview: [],
  historyPhone: [],
  phoneNumbers: [],

  queuePause: queueRequest.queue,
  queueContinue: queueContinue.queue,
  queueMarkAs: queueMarkAsComplete.queue,
  queueFetchingCreativeCampaign: queueFetchingCreativeCampaign.queue,
  queueRefreshing: queueRefreshing.queue,
  errorGetPhoneNumbers: null,
  ...baseSendInbox(),
};

export default (state, actions) => {
  // Fix case "switch to large case"
  const listActions = {
    [REQUEST_SWITCH_STATUS_ROUTE_HISTORY_SUCCESS]: () => {
      return {
        ...state,
        historyPhone: {
          ...state.historyPhone,
          history: actions.nextHistory,
        },
      };
    },
    [REQUEST_REFRESH_CAMPAIGN]: () => {
      queueRefreshing.pushToQueue(actions.id);
      return {
        ...state,
        queueRefreshing: queueRefreshing.queue,
      };
    },
    [REQUEST_REFRESH_CAMPAIGN_SUCCESS]: () => {
      queueRefreshing.removeFromQueue(actions.id);
      return {
        ...state,
        queueRefreshing: queueRefreshing.queue,
      };
    },
    [REQUEST_REFRESH_CAMPAIGN_FAILED]: () => {
      queueRefreshing.removeFromQueue(actions.id);
      return {
        ...state,
        queueRefreshing: queueRefreshing.queue,
      };
    },
    [types.UPDATE_CAMPAIGN]: () => ({
      ...state,
      historyPhone: {
        ...state.historyPhone,
        history: actions.history,
      },
    }),
    [types.REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID]: () => {
      actions.listCpId.forEach((id) => {
        queueFetchingCreativeCampaign.pushToQueue(id);
      });
      return {
        ...state,
        queueFetchingCreativeCampaign: queueFetchingCreativeCampaign.queue,
      };
    },
    [types.REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID_SUCCESS]: () => {
      queueFetchingCreativeCampaign.removeFromQueue(actions.cpId);
      return {
        ...state,
        queueFetchingCreativeCampaign: queueFetchingCreativeCampaign.queue,
      };
    },
    [types.REQUEST_GET_CREATIVE_BY_CAMPAIGN_ID_FAILED]: () => {
      queueFetchingCreativeCampaign.removeFromQueue(actions.cpId);
      return {
        ...state,
        queueFetchingCreativeCampaign: queueFetchingCreativeCampaign.queue,
      };
    },
    [REQUEST_FILTER_CAMPAIGN]: () => ({
      ...state,
      isFiltering: true,
      isLastHistory: false,
    }),
    [REQUEST_FILTER_CAMPAIGN_SUCCESS]: () => ({
      ...state,
      isFiltering: false,
    }),
    [REQUEST_FILTER_CAMPAIGN_FAILED]: () => ({
      ...state,
      isFiltering: false,
    }),
    [REQUEST_UPDATE_MESSAGE_HIST]: () => ({
      ...state,
      isSaving: true,
    }),

    [REQUEST_SORTING_CAMPAIGN]: () => ({
      ...state,
      isSorting: true,
    }),

    [REQUEST_SORTING_CAMPAIGN_SUCCESS]: () => ({
      ...state,
      isSorting: false,
      historyPhone: {
        ...state.historyPhone,
        history: actions.nextHistory,
      },
      isLastHistory: actions.isLastHistory,
    }),

    [REQUEST_SORTING_CAMPAIGN_FAILED]: () => ({
      ...state,
      isSorting: false,
    }),

    [REQUEST_UPDATE_MESSAGE_HIST_SUCCESS]: () => {
      // const historyPhone =
      // 	state.historyPhone.history && typeof state.historyPhone.history === 'object'
      // 		? [ ...state.historyPhone.history ]
      // 		: [];
      // const item = actions.history;
      // const index = historyPhone.findIndex((el) => el.id === item.id);
      // if (~index) {
      // 	historyPhone[index] = item;
      // }
      return {
        ...state,
        isSaving: false,
        // historyPhone: {
        // 	...state.historyPhone,
        // 	history: historyPhone
        // }
      };
    },
    [REQUEST_UPDATE_MESSAGE_HIST_FAILED]: () => ({
      ...state,
      isSaving: false,
      errorUpdate: actions.error,
    }),
    [REQUEST_MARK_AS_COMPLETED]: () => {
      queueMarkAsComplete.pushToQueue(actions.cpId);
      return {
        ...state,
        isMarking: true,
        queueMarkAs: queueMarkAsComplete.queue,
      };
    },
    [REQUEST_MARK_AS_COMPLETED_SUCCESS]: () => {
      queueMarkAsComplete.removeFromQueue(actions.cpId);
      return {
        ...state,
        isMarking: false,
        queueContinue: queueContinue.queue,
        historyPhone: {
          ...state.historyPhone,
          history: actions.history,
        },
        queueMarkAs: queueMarkAsComplete.queue,
      };
    },
    [REQUEST_MARK_AS_COMPLETED_FAILED]: () => {
      queueMarkAsComplete.removeFromQueue(actions.cpId);
      return {
        ...state,
        isMarking: false,
        errorMarkAs: actions.error,
        queueMarkAs: queueMarkAsComplete.queue,
      };
    },
    [REQUEST_CONTINUE_HIST]: () => {
      queueContinue.pushToQueue(actions.histId);
      return {
        ...state,
        isContinuing: true,
        queueContinue: queueContinue.queue,
      };
    },
    [REQUEST_CONTINUE_HIST_SUCCESS]: () => {
      queueContinue.removeFromQueue(actions.histId);
      return {
        ...state,
        isContinuing: false,
        queueContinue: queueContinue.queue,
        historyPhone: {
          ...state.historyPhone,
          history: actions.history,
        },
      };
    },
    [REQUEST_CONTINUE_HIST_FAILED]: () => {
      queueContinue.removeFromQueue(actions.histId);
      return {
        ...state,
        isContinuing: false,
        queueContinue: queueContinue.queue,
        errorContinue: actions.error,
      };
    },
    [REQUEST_PAUSE_LOAD_HISTORY]: () => {
      queueRequest.pushToQueue(actions.id);
      return {
        ...state,
        isPausing: true,
        queuePause: queueRequest.queue,
      };
    },
    [REQUEST_PAUSE_LOAD_HISTORY_SUCCESS]: () => {
      queueRequest.removeFromQueue(actions.id);
      return {
        ...state,
        isPausing: false,
        queuePause: queueRequest.queue,
      };
    },
    [REQUEST_PAUSE_LOAD_HISTORY_FAILED]: () => {
      queueRequest.removeFromQueue(actions.id);
      return {
        ...state,
        isPausing: false,
        errorPause: actions.error,
        queuePause: queueRequest.queue,
      };
    },
    [REQUEST_MORE_HISTORY]: () => ({
      ...state,
      isLoadMore: true,
      isLastHistory: false,
    }),
    [REQUEST_MORE_HISTORY_SUCCESS]: () => {
      const newHistoryPhone =
        actions.offset === 0
          ? [...actions.historyPhone.history]
          : [...state.historyPhone.history, ...actions.historyPhone.history];
      return {
        ...state,
        isLoadMore: false,
        historyPhone: {
          history: newHistoryPhone,
        },
      };
    },
    [IS_LAST_HISTORY]: () => ({
      ...state,
      isLoadMore: false,
      isLastHistory: actions.isLastHistory,
    }),
    [REQUEST_MORE_HISTORY_FAILED]: () => ({
      ...state,
      isLoadMore: false,
      isLastHistory: false,
      errorLoadMore: actions.errorLoadMore,
    }),
    [REQUEST_HISTORY_BY_ID]: () => ({
      ...state,
      isFetchingHisById: true,
    }),
    [REQUEST_HISTORY_BY_ID_SUCCESS]: () => {
      const historyPhone = state.historyPhone.history || [];
      const dataPayload = actions.data.history;

      const newHistory = [...historyPhone];
      newHistory.forEach((his, index) => {
        const itemFind = dataPayload.find((his2) => his.id === his2.id);
        if (itemFind) {
          newHistory[index] = itemFind;
        }
      });

      return {
        ...state,
        historyPhone: {
          ...state.historyPhone,
          history: newHistory,
        },
        isFetchingHisById: false,
      };
    },
    [REQUEST_HISTORY_BY_ID_FAILED]: () => ({
      ...state,
      errorGetHisById: actions.error,
    }),
    [REQUEST_PREVIEW_SPIN]: () => ({
      ...state,
      isPreview: true,
    }),
    [REQUEST_PREVIEW_SPIN_SUCCESS]: () => ({
      ...state,
      isPreview: false,
      string: actions.string,
      listStringPreview: actions.listStringPreview,
    }),
    [REQUEST_PREVIEW_SPIN_FAILED]: () => ({
      ...state,
      isPreview: false,
      errorPreview: actions.error,
    }),
    [REQUEST_CLEAR_PREVIEW_SPIN]: () => ({
      ...state,
      isPreview: false,
      string: '',
      listStringPreview: [],
    }),
    [REQUEST_SPIN_SERVLET]: () => ({
      ...state,
      isSpinging: true,
    }),
    [REQUEST_SPIN_SERVLET_SUCCESS]: () => ({
      ...state,
      isSpinging: false,
      isSpinSuccess: true,
    }),
    [REQUEST_SPIN_SERVLET_FAILED]: () => ({
      ...state,
      isSpinging: false,
      isSpinSuccess: false,
      errorSpin: actions.error,
    }),
    [REQUEST_CLEAR_SPIN]: () => ({
      ...state,
      errorSpin: actions.error,
      isSpinging: false,
      isSpinSuccess: false,
    }),
    [REQUEST_SEND_SERVLET]: () => ({
      ...state,
      isSending: true,
    }),
    [REQUEST_SEND_SERVLET_SUCCESS]: () => ({
      ...state,
      isSending: false,
    }),
    [REQUEST_SEND_SERVLET_FAILED]: () => ({
      ...state,
      isSending: false,
    }),
    [REQUEST_SEND_INBOX_SERVLET]: () => fetchSendInbox(actions, state),
    [REQUEST_SEND_INBOX_SERVLET_SUCCESS]: () => fetchSendInboxSuccess(actions, state),
    [REQUEST_SEND_INBOX_SERVLET_FAILED]: () => fetchSendInboxFailed(actions, state),

    [REQUEST_API_SERVLET]: () => ({
      ...state,
      isFetching: true,
      isFetchingServlet: true,
    }),
    [REQUEST_API_SERVLET_SUCCESS]: () => ({
      ...state,
      historyPhone: actions.historyPhone,
      isFetching: false,
      isFetchingServlet: false,
    }),
    [REQUEST_API_SERVLET_FAILED]: () => ({
      ...state,
      error: actions.error,
      isFetching: false,
      isFetchingServlet: false,
    }),
    [REQUEST_PHONE_NUMBERS]: () => ({
      ...state,
      error: actions.error,
      isFetching: true,
    }),
    [REQUEST_PHONE_NUMBERS_FAILED]: () => ({
      ...state,
      isFetching: false,
      errorGetPhoneNumbers: actions.error,
    }),
    [REQUEST_PHONE_NUMBERS_SUCCESS]: () => ({
      ...state,
      isFetching: false,
      errorGetPhoneNumbers: null,
      phoneNumbers: actions.phoneNumbers,
    }),
    [REQUEST_PULL_REVENUE_CAMPAIGN]: () => {
      return {
        ...state,
        isPullingRevenue: true,
      };
    },
    [REQUEST_PULL_REVENUE_CAMPAIGN_SUCCESS]: () => {
      return {
        ...state,
        isPullingRevenue: false,
      };
    },
    [REQUEST_PULL_REVENUE_CAMPAIGN_FAILED]: () => {
      return {
        ...state,
        isPullingRevenue: false,
      };
    },
    [REQUEST_UPDATE_STATUS_CONTACT_GROUP_SUCCESS]: () => {
      return {
        ...state,
        historyPhone: {
          ...state.historyPhone,
          history: actions.nextHistory,
        },
      };
    },
    [REQUEST_CLEAR_SERVLET]: () => initialState,
    [typeUnmounted(components.send)]: () => initialState,
    [typeUnmounted(components.monitoring)]: () => initialState,
  };

  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  if (listActions[actions.type]) {
    return listActions[actions.type]();
  }
  return state;
};
